import Demo from './lib/demo/index.vue'
import Card from './lib/card/index.vue'

const components = {
  Demo,
  Card
}
console.log(11,components)
const install = function (Vue) {
  if (install.installed) return
  Object.keys(components).forEach(key => {
    Vue.component(components[key].name, components[key])
  })
}

export default {
  install
}